import { StockGroupByBloccoModel } from 'Magazzino/Models/StockGroupByBloccoModel';

import { PreferitiModel } from '../Models/PreferitiModel';

export class GestionePreferiti {
    public static aggiungi(preferito: PreferitiModel): void {
        const preferiti: PreferitiModel[] = JSON.parse(localStorage.getItem('preferiti') || '[]');
        preferiti.push(preferito);
        localStorage.setItem('preferiti', JSON.stringify(preferiti));
    }

    public static modifica(id: string, nuovoPreferito: PreferitiModel): void {
        const preferiti: PreferitiModel[] = JSON.parse(localStorage.getItem('preferiti') || '[]');
        const indice = preferiti.findIndex((p) => p.id === id);
        if (indice !== -1) {
            preferiti[indice] = nuovoPreferito;
            localStorage.setItem('preferiti', JSON.stringify(preferiti));
        }
    }

    public static elimina(id: string): void {
        let preferiti: PreferitiModel[] = JSON.parse(localStorage.getItem('preferiti') || '[]');
        preferiti = preferiti.filter((p) => p.id !== id);
        localStorage.setItem('preferiti', JSON.stringify(preferiti));
    }

    public static getAll(): PreferitiModel[] {
        const preferiti: PreferitiModel[] = JSON.parse(localStorage.getItem('preferiti') || '[]');
        return preferiti;
    }

    public static get(id: string): PreferitiModel | undefined {
        const preferiti: PreferitiModel[] = JSON.parse(localStorage.getItem('preferiti') || '[]');

        const rigastock = preferiti.find((x) => x.id === id);

        return rigastock;
    }

    public static getByStockGroupByBloccoModel(p: StockGroupByBloccoModel): PreferitiModel | null {
        const id = this.getIdByStockGroupByBloccoModel(p);

        const preferiti: PreferitiModel[] = JSON.parse(localStorage.getItem('preferiti') || '[]');

        const rigastock = preferiti.find((x) => x.id === id);

        return rigastock ? rigastock : null;
    }

    public static getIdByStockGroupByBloccoModel(p: StockGroupByBloccoModel) {
        const id =
            p.numeroBlocco +
            '_' +
            p.numeroBloccoFornitore +
            '_' +
            p.monolama +
            '_' +
            p.idQualita +
            '_' +
            p.codFinitura +
            '_' +
            p.spessore +
            '_' +
            p.um;

        return id;
    }
}
